import {ModalBody, ModalFooter, ModalHeader} from "@heroui/modal";
import {Card} from "@heroui/card";
import React from "react";
import {logger} from "@/components/DownloaderApp/logger";
import {useMonitoring} from "@/components/monitoring";

function secondsToMinutes(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedMinutes = String(minutes).padStart(1, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
}

function timeAgo(timestamp) {
    const now = Date.now();
    const diffInSeconds = Math.floor((now - +timestamp) / 1000);

    const secondsInMinute = 60;
    const secondsInHour = 3600;
    const secondsInDay = 86400;
    const secondsInMonth = 2592000; // approx. 30 days
    const secondsInYear = 31536000; // approx. 365 days

    if (diffInSeconds < secondsInMinute) {
        return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < secondsInHour) {
        const minutes = Math.floor(diffInSeconds / secondsInMinute);
        return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < secondsInDay) {
        const hours = Math.floor(diffInSeconds / secondsInHour);
        return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < secondsInMonth) {
        const days = Math.floor(diffInSeconds / secondsInDay);
        return `${days} day${days !== 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < secondsInYear) {
        const months = Math.floor(diffInSeconds / secondsInMonth);
        return `${months} month${months !== 1 ? 's' : ''} ago`;
    } else {
        const years = Math.floor(diffInSeconds / secondsInYear);
        return `${years} year${years !== 1 ? 's' : ''} ago`;
    }
}

function buildClipUrl(clip) {
    return `https://kick.com/${clip.channel.slug}/clips/${clip.id}`
}

function VideoOverlay({children, className}) {
    return <div className={`${className} bg-black opacity-75 text-white text-sm p-0.5`}>{children}</div>
}

export function ClipsPopup({data, onAccept}) {
    logger.log(data.clips);
    const {track} = useMonitoring();

    return (
        <>
            <ModalHeader className="flex flex-col gap-1">
        <span id="modal-title">
          {`Choose '@${data.channelName}' clip to download`}
        </span>
            </ModalHeader>
            <ModalBody>
                <div className="gap-3 grid grid-cols-3 scroll-auto">
                    {data.clips.map((item, i) =>
                        (<Card className="rounded-md cursor-pointer" key={item.clip_url}>
                            <a target={"_blank"} href={`?download=${buildClipUrl(item)}&s=c`}
                               onClick={() => track("Clip selected do download", {...item})}>
                                <div>
                                    <img src={item.thumbnail_url}/>
                                    <VideoOverlay
                                        className={"absolute top-1 left-1 pt-0"}>{secondsToMinutes(item.duration)}</VideoOverlay>
                                    <VideoOverlay
                                        className={"absolute bottom-8 left-1"}>{item.views} views</VideoOverlay>
                                    <VideoOverlay
                                        className={"absolute bottom-8 right-1"}>{timeAgo(new Date(item.created_at))}</VideoOverlay>
                                </div>
                                <p className={"text-sm truncate whitespace-nowrap overflow-hidden py-1 px-2"}>{item.title}</p>
                            </a>
                        </Card>))
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                {/*<Button color="primary" onPress={onClose}>*/}
                {/*    I'll double-check!*/}
                {/*</Button>*/}
            </ModalFooter>
        </>
    );
}